import { AdminReviewSessionViewDto } from "@swagger/typescript-fetch-goflyer";
import { CommentsPanel } from "../CommentsPanel";

interface Props {
  flyerId: string;
  reqOptions: { headers: { Authorization: string } };
  bootstrap: AdminReviewSessionViewDto | undefined;
}

export function FlyerCommentsPanel({
  flyerId,
  reqOptions,
  bootstrap,
}: Props) {
  return (
    <CommentsPanel
      flyerId={flyerId}
      reqOptions={reqOptions}
      bootstrap={bootstrap}
      targetTypeFilter="FLYER"
    />
  );
}
